export enum ChallengeCurrency {
  EUR = 'EUR',
  USD = 'USD',
}
